import { useEffect, useRef } from 'react'

/**
 * Closes a custom (non-Chakra) popup on Escape while it is open, wherever
 * focus is inside the page. Pair with an expanded trigger
 * (`aria-expanded="true"`) so an enclosing `Modal` leaves Escape to the popup.
 */
export function useEscapeToClosePopup(
  isOpen: boolean,
  onClose: () => void,
): void {
  const onCloseRef = useRef(onClose)
  onCloseRef.current = onClose

  useEffect(() => {
    if (!isOpen) return
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key !== 'Escape' || event.isComposing) return
      event.preventDefault()
      onCloseRef.current()
    }
    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [isOpen])
}
